import { __awaiter } from "tslib";
export function delayPromise(basePromise, minTimeToWait) {
    return new Promise((onResolve, onReject) => __awaiter(this, void 0, void 0, function* () {
        let isResolved = false;
        let timeoutDone = false;
        let isHandled = false;
        function handlerFunc() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!timeoutDone) {
                    return;
                }
                if (!isResolved) {
                    yield basePromise;
                    isResolved = true;
                }
                if (isHandled) {
                    return;
                }
                basePromise.then(onResolve).catch(onReject);
            });
        }
        setTimeout(() => {
            timeoutDone = true;
            handlerFunc();
        }, minTimeToWait);
        yield basePromise;
        isResolved = true;
        handlerFunc;
        basePromise.then(() => {
            isResolved = true;
            handlerFunc();
        }).catch(() => {
            isResolved = true;
            handlerFunc();
        });
        handlerFunc();
    }));
}
